import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  isExternal?: boolean;
  href?: string;
}
export function CTAButton({
  text,
  onClick,
  className = '',
  isExternal = false,
  href
}: CTAButtonProps) {
  const baseClasses = 'group relative inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-xl md:text-2xl font-black text-white bg-gradient-to-b from-[#22c55e] to-[#16a34a] rounded-xl shadow-[0_8px_0_#15803d,0_15px_20px_rgba(0,0,0,0.4)] hover:shadow-[0_6px_0_#15803d,0_10px_15px_rgba(0,0,0,0.4)] hover:translate-y-[2px] active:shadow-[0_0px_0_#15803d,0_0px_0px_rgba(0,0,0,0.4)] active:translate-y-[8px] transition-all duration-150 animate-pulse-slow uppercase tracking-wide border-2 border-green-300';
  if (isExternal && href) {
    return <a href={href} className={`${baseClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-84">
        <span className="drop-shadow-md" data-id="element-85">{text}</span>
        <ArrowRightIcon className="ml-3 w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-2 transition-transform drop-shadow-md" strokeWidth={3} data-id="element-86" />
      </a>;
  }
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    } else {
      const pricingSection = document.getElementById('compra');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-87">
      <span className="drop-shadow-md" data-id="element-88">{text}</span>
      <ArrowRightIcon className="ml-3 w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-2 transition-transform drop-shadow-md" strokeWidth={3} data-id="element-89" />
    </button>;
}